const translations = {
    'tooltip.biome': 'biome: %s',
    'tooltip.id': 'id: %s',
    'tooltip.qrs': 'q/r/s: %d/%d/%d',
    'tooltip.resources': 'resources: %s',
    'tooltip.resourcesHeader': 'resources:',
    'tooltip.unknown': 'unknown region',
};

export default translations;
